import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import React from "react";
import TextFieldFormControl from "../../field/TextFieldFormControl/TextFieldFormControl";
import IntegerField from "../../base/IntegerField/IntegerField";
import DateField from "../../field/DateField/DateField";
import AutocompleteField from "../../field/AutocompleteField/AutocompleteField";

const HrSurveyMainDataForm = React.memo(({
  surveyData,
  filteringData,
  readOnly,
  onChange,
  onChangeDate,
  onChangeAutocomplete,
  onBlur,
  expirationMinDate
}) => {
  const { t } = useTranslation();

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      spacing={1}
    >

      <Grid item xs={12} md={6} container spacing={1} alignContent="flex-start">
        <Grid item xs={12}>
          <TextFieldFormControl
            name="hrsurvey_name"
            label={t("form.hr_survey_main_data_form.name")}
            value={surveyData?.hrsurvey_name}
            onChange={onChange}
            onBlur={onBlur}
            readOnly={readOnly}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextFieldFormControl
            name="hrsurvey_goal"
            label={t("form.hr_survey_main_data_form.goal")}
            value={surveyData?.hrsurvey_goal}
            onChange={onChange}
            onBlur={onBlur}
            readOnly={readOnly}
            multiline
            rows={4}
            resize="vertical"
          />
        </Grid>
        <Grid item xs={12}>
          <TextFieldFormControl
            name="hrsurvey_invitation"
            label={t("form.hr_survey_main_data_form.invitation_content")}
            value={surveyData?.hrsurvey_invitation}
            onChange={onChange}
            onBlur={onBlur}
            readOnly={readOnly}
            multiline
            rows={4}
            resize="vertical"
          />
        </Grid>
      </Grid>


      <Grid item xs={12} md={6} container spacing={1} alignContent="flex-start">
        <Grid item xs={12}>
          <DateField
            name="created"
            label={t("form.hr_survey_main_data_form.creation_date")}
            value={surveyData?.created}
            readOnly={true}
          />
        </Grid>
        <Grid item xs={12}>
          <DateField
            name="hrsurvey_date_send"
            label={t("form.hr_survey_main_data_form.send_date")}
            value={surveyData?.hrsurvey_date_send}
            readOnly={true}
          />
        </Grid>
        <Grid item xs={6}>
          <IntegerField
            name="hrsurvey_reminder1"
            label={t("form.hr_survey_main_data_form.reminder1_days")}
            value={surveyData?.hrsurvey_reminder1}
            onChange={onChange}
            onBlur={onBlur}
            readOnly={readOnly}
            min={1}
          />
        </Grid>
        <Grid item xs={6}>
          <IntegerField
            name="hrsurvey_reminder2"
            label={t("form.hr_survey_main_data_form.reminder2_days")}
            value={surveyData?.hrsurvey_reminder2}
            onChange={onChange}
            onBlur={onBlur}
            readOnly={readOnly}
            min={1}
          />
        </Grid>
        <Grid item xs={12}>
          <DateField
            name="hrsurvey_date_expired"
            label={t("form.hr_survey_main_data_form.expiration_date")}
            value={surveyData?.hrsurvey_date_expired}
            onChange={onChangeDate}
            minDate={expirationMinDate}
            onBlur={onBlur}
            readOnly={readOnly}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <DateField
            name="hrsurvey_date_close"
            label={t("form.hr_survey_main_data_form.closing_date")}
            value={surveyData?.hrsurvey_date_close}
            readOnly={true}
          />
        </Grid>
        <Grid item xs={12}>

          <TextFieldFormControl
            name="creator"
            label={t("form.hr_survey_main_data_form.organizer")}
            value={surveyData?.creator}
            readOnly={true}

          />
        </Grid>

      </Grid>
    </Grid>
  );
});

HrSurveyMainDataForm.propTypes = {
  surveyData: PropTypes.object,
  filteringData: PropTypes.object,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  onChangeDate: PropTypes.func,
  onChangeAutocomplete: PropTypes.func,
  onBlur: PropTypes.func,
};

HrSurveyMainDataForm.defaultProps = {
  readOnly: false,
};

export default HrSurveyMainDataForm;
